setUserAccountCancelSubscriptionConfirmData